import {
    parseDateRange, dateRangeToString, objectMap, objectFilter,
} from './helpers';

const addHashToLocation = (url) => {
    window.history.pushState({}, null, url);
};

const redirectTo = (relativePath, params = null, openInNewWindow = false) => {
    const url = new URL(relativePath, window.location.origin);
    if (params) {
        url.search = new URLSearchParams(params);
    }
    if (openInNewWindow) {
        window.open(url.toString(), '_blank').focus();
    } else {
        window.location.href = url.toString();
    }
};

const urlParamsToJson = (obj, isDefaultData = false) => {
    const url = new URL(window.location.href);
    const urlParams = new URLSearchParams(url.search);

    const results = objectMap(obj, (value) => {
        const { defaultValue } = value;

        if (isDefaultData) {
            return defaultValue;
        }

        const urlParamValue = urlParams.get(value.urlParamName);

        if (!urlParamValue) {
            return defaultValue;
        }

        if (Array.isArray(defaultValue)) {
            return urlParamValue.split(',');
        }
        if (typeof defaultValue === 'number') {
            return parseFloat(urlParamValue);
        }
        if (typeof defaultValue === 'object' && defaultValue.hasOwnProperty('startDate') && defaultValue.startDate === null) {
            return parseDateRange(urlParamValue);
        }

        return urlParamValue;
    });

    return results;
};

const getUrlSegment = (urlSegment) => {
    const url = new URL(window.location.href);
    const { pathname } = url;
    const pathnameParts = pathname.split('/');
    return pathnameParts[urlSegment];
};

const replaceUrlParams = (url, obj) => {
    const filteredParams = objectFilter(obj, (value) => {
        if (value === null) {
            return '';
        }
        if (Array.isArray(value)) {
            return value.length !== 0;
        }
        if (typeof value === 'boolean') {
            return value !== false;
        }
        if (typeof value === 'object' && value.hasOwnProperty('startDate') && value.startDate === null) {
            return false;
        }
        return value !== '';
    });
    const mappedParams = objectMap(filteredParams, (value) => {
        if (typeof value === 'object' && value.startDate !== undefined) {
            return dateRangeToString(value);
        }
        return value;
    });

    url.search = new URLSearchParams(mappedParams);

    return url;
};

const getUrlParam = (paramName, defaultValue = undefined) => {
    const url = new URL(window.location.href);
    const urlParams = new URLSearchParams(url.search);
    if (urlParams.has(paramName)) {
        return urlParams.get(paramName);
    }
    return defaultValue;
};

const getSearchUrlSegment1 = (isRent, propertyType = null) => {
    let propType = null;
    if (Array.isArray(propertyType) && propertyType.length === 1) {
        propType = propertyType[0];
    } else if (propertyType && propertyType.length) {
        propType = propertyType;
    }
    if (isRent) {
        switch (propType) {
        case 'flat':
            return 'flats-to-rent';
        case 'house':
            return 'houses-to-rent';
        case 'studio':
            return 'studios-to-rent';
        case 'room':
            return 'rooms-to-rent';
        default:
            return 'properties-to-rent';
        }
    } else {
        switch (propType) {
        case 'flat':
            return 'want-flat';
        case 'house':
            return 'want-houses';
        case 'room':
            return 'want-rooms';
        default:
            return 'want-properties';
        }
    }
};

const replaceUrlSegments = (url, segmentsObject) => {
    const { pathname } = url;
    const pathnameParts = pathname.split('/');

    Object.keys(segmentsObject).forEach((key) => {
        pathnameParts[key] = segmentsObject[key];
    });

    url.pathname = pathnameParts.join('/');

    return url;
};

const replaceUrl = (url) => {
    const curUrl = new URL(window.location.href);
    if (curUrl.pathname !== url.pathname || curUrl.search !== url.search) {
        addHashToLocation(url);
    }
};

const replaceSearchUrl = (isRent, propertyType, area, filters, isMapView = false) => {
    let url = new URL(window.location.href);

    const urlSegment1 = getSearchUrlSegment1(isRent, propertyType);
    const urlSegment2 = (area && area.slug) ? area.slug : null;

    if (isMapView) {
        url = replaceUrlSegments(url, {
            1: 'map',
            2: urlSegment1,
            3: urlSegment2,
        });
    } else {
        url = replaceUrlSegments(url, {
            1: urlSegment1,
            2: urlSegment2,
        });
    }

    url = replaceUrlParams(url, filters);

    replaceUrl(url);
};

export {
    getUrlSegment,
    replaceSearchUrl,
    getSearchUrlSegment1,
    replaceUrlParams,
    replaceUrl,
    urlParamsToJson,
    getUrlParam,
    redirectTo,
};
